import { ADD_CACHE, PURGE_CACHE } from './constants';

export const addCache = (keyPath, values) => ({
	type: ADD_CACHE,
	keyPath,
	values,
});

export const purgeCache = keyPath => ({
	type: PURGE_CACHE,
	keyPath,
});
